import React, { Component } from 'react';
import { any, bool } from 'prop-types';
import { connect } from 'react-redux';
import { WithLoading } from '@widergy/energy-ui';

import {
  getTotalAmount,
  getPayableBills,
  getBillListTotalAmount
} from '../../../AccountHolderChange/accountHolderChangeHelper';
import { actionCreators as paymentActions } from '../../../../../../../redux/paymentHandlers';
import { actionCreators as customProceduresActions } from '../../../../../../../redux/customProceduresHandlers';
import AccountHolderChangeHistory from '../../../AccountHolderChange/components/AccountHolderChangeHistory/layout';

class TerminationRequestDetails extends Component {
  componentDidUpdate() {
    if (this.props.paymentRequestSuccess) {
      this.props.dispatch(customProceduresActions.cancelCustomProcedureSuccess());
    }
  }

  getPayableBills = () => getPayableBills(this.props.accountTotalDebt && this.props.accountTotalDebt.Recibos);

  getSupplyPayableBills = () =>
    getPayableBills(
      this.props.customProcedureData &&
        JSON.parse(this.props.customProcedureData.CONTENIDO) &&
        JSON.parse(this.props.customProcedureData.CONTENIDO).RecibosSuministro
    );

  handleOnProcedureCancel = () => {
    this.props.dispatch(
      customProceduresActions.cancelCustomProcedure(
        this.props.customProcedureData && this.props.customProcedureData.Id,
        this.props.customProcedureData
      )
    );
  };

  handleAccountPayment = () => {
    const totalAmount =
      (this.props.customProcedureData &&
        this.props.customProcedureData.CONTENIDO &&
        JSON.parse(this.props.customProcedureData.CONTENIDO).DeudaConsolidadaSuministro) ||
      getTotalAmount(this.props.accountTotalDebt, this.props.accountDueDebt);

    const amountList = this.getPayableBills() || this.getSupplyPayableBills();

    this.props.dispatch(
      paymentActions.paymentFlowInit(
        totalAmount,
        amountList,
        this.props.customProcedureData && this.props.customProcedureData.Id
      )
    );
  };

  render() {
    return (
      <div>
        <AccountHolderChangeHistory
          onProcedureCancel={this.handleOnProcedureCancel}
          onPayment={this.handleAccountPayment}
          processHistory={this.props.customProcedureData}
          formType="Baja del suministro"
          clientNumber={
            this.props.customProcedureData &&
            this.props.customProcedureData.CONTENIDO &&
            JSON.parse(this.props.customProcedureData.CONTENIDO).NIS
          }
          bills={this.props.customProcedureData && JSON.parse(this.props.customProcedureData.CONTENIDO)}
          accountTotalDebt={
            (this.props.customProcedureData &&
              this.props.customProcedureData.CONTENIDO &&
              JSON.parse(this.props.customProcedureData.CONTENIDO).DeudaConsolidadaSuministro) ||
            getBillListTotalAmount(this.props.billList, false)
          }
          accountDueDebt={
            (this.props.customProcedureData &&
              this.props.customProcedureData.CONTENIDO &&
              JSON.parse(this.props.customProcedureData.CONTENIDO).DeudaCliente) ||
            0
          }
          showOnlyHistory={
            this.props.customProcedureData &&
            this.props.customProcedureData.ProcessActivity &&
            this.props.customProcedureData.ProcessActivity.State &&
            this.props.customProcedureData.ProcessActivity.State.Name === 'PendienteOpenSGC'
          }
        />
      </div>
    );
  }
}

TerminationRequestDetails.propTypes = {
  accountsData: any, // eslint-disable-line
  customProcedureData: any, // eslint-disable-line
  accountTotalDebt: any, // eslint-disable-line
  accountDueDebt: any, // eslint-disable-line
  billList: any, // eslint-disable-line
  paymentRequestSuccess: bool
};

const mapStateToProps = store => ({
  paymentRequestSuccess: store.customProcedures.paymentRequestSuccess
});

export default WithLoading(props => props.loading)(connect(mapStateToProps)(TerminationRequestDetails));
